import React from 'react';
import { FaInbox, FaSearch, FaPlus, FaFolderOpen } from 'react-icons/fa';

const PRESETS = {
  default: { icon: FaInbox, title: 'No Data Available', description: 'There is nothing to display here yet.' },
  search: { icon: FaSearch, title: 'No Results Found', description: 'Try adjusting your search or filter criteria.' },
  create: { icon: FaPlus, title: 'Get Started', description: 'Create your first item to see it here.' },
  folder: { icon: FaFolderOpen, title: 'Empty Folder', description: 'This section has no content yet.' },
};

const EmptyState = ({
  icon: Icon,
  title,
  description,
  preset = 'default',
  action,
  actionLabel,
  onAction,
  className = '',
  compact = false,
}) => {
  const presetConfig = PRESETS[preset] || PRESETS.default;
  const DisplayIcon = Icon || presetConfig.icon;
  const displayTitle = title || presetConfig.title;
  const displayDescription = description || presetConfig.description;

  return (
    <div className={`flex flex-col items-center justify-center text-center ${compact ? 'py-12 px-4' : 'py-16 md:py-20 px-6'} ${className}`}>
      <div className="relative mb-6">
        <div className="absolute inset-0 bg-gradient-to-br from-primary-500/20 to-secondary-500/20 rounded-full blur-2xl scale-150" />
        <div className={`relative ${compact ? 'w-16 h-16' : 'w-24 h-24'} rounded-2xl glass flex items-center justify-center shadow-3d transform rotate-3 hover:rotate-0 transition-transform duration-500`}>
          <DisplayIcon className={`${compact ? 'w-7 h-7' : 'w-10 h-10'} text-primary-500 dark:text-primary-400`} />
        </div>
        <div className="absolute -bottom-1 -right-1 w-4 h-4 bg-secondary-500 rounded-full animate-pulse" />
      </div>

      <h3 className={`${compact ? 'text-base' : 'text-xl'} font-bold text-gray-900 dark:text-white mb-2`}>
        {displayTitle}
      </h3>
      <p className={`text-gray-500 dark:text-gray-400 max-w-sm ${compact ? 'text-sm' : 'text-base'} mb-6`}>
        {displayDescription}
      </p>

      {(action || onAction) && (
        <div>
          {action || (
            <button onClick={onAction} className="btn-premium flex items-center gap-2">
              <FaPlus className="w-4 h-4" />
              {actionLabel || 'Create New'}
            </button>
          )}
        </div>
      )}
    </div>
  );
};

export const EmptyTableRow = ({ colSpan, preset = 'search', title, description }) => (
  <tr>
    <td colSpan={colSpan} className="p-0">
      <EmptyState preset={preset} title={title} description={description} compact />
    </td>
  </tr>
);

export default EmptyState;
